/**
 * Customer copy for API errors, keyed by the `reason` the backend sends
 * (docs/standards/i18n.md). A reason with no entry here falls back to the
 * API's own `message`.
 */
export const messages = {
  "auth.credentials.invalid": "That email, phone number or password is incorrect.",
  "auth.password.incorrect": "Your current password is incorrect.",
  "auth.password.too_short": "Use a password of at least {min_length} characters.",
  "auth.pin.already_set": "Your transaction PIN is already set up.",
  "auth.pin.incorrect": "That PIN is incorrect.",
  "auth.pin.invalid_length": "Your PIN must be {digits} digits.",
  "auth.pin.locked": "Too many incorrect PIN attempts. Your PIN is locked for now.",
  "auth.pin.setup_required": "Set up your transaction PIN before continuing.",
  "auth.pin.too_predictable": "Choose a less predictable PIN.",
  "auth.pin.unchanged": "Your new PIN must be different from the current one.",
  "auth.reset_code.incorrect": "That code is incorrect. Attempts left: {attempts_remaining}.",
  "auth.reset_code.invalid": "This reset code is invalid or has expired. Request a new one.",
  "auth.reset_code.locked": "Too many incorrect codes. Try again later.",
  "auth.verification_code.expired": "This code has expired. Request a new one.",
  "auth.verification_code.resend_too_soon":
    "Wait {retry_after_seconds} seconds before requesting another code.",
  "auth.verification_code.used": "This code has already been used.",
  "chat.message.card_details_not_allowed":
    "Never type card numbers or bank details in the chat. Use the forms in the app.",
  "chat.message.daily_limit_reached":
    "You've sent the most chat messages allowed today. You can still use the app menus.",
  "chat.message.pin_not_allowed":
    "Never type your PIN in the chat. Enter it only in the secure PIN box.",
  "errors.common.not_authorized": "You can't do that.",
  "errors.common.processing": "We couldn't process this request right now.",
  "errors.common.rejected": "We couldn't complete this request.",
};

/**
 * Reasons that come from PIN and password checks. Only these are shown on
 * PIN screens; anything else there gets the screen's fallback.
 */
export const AUTH_REASONS = new Set([
  "auth.password.incorrect",
  "auth.pin.already_set",
  "auth.pin.incorrect",
  "auth.pin.invalid_length",
  "auth.pin.locked",
  "auth.pin.setup_required",
  "auth.pin.too_predictable",
  "auth.pin.unchanged",
]);

export function errorCopy(reason, values) {
  const template = messages[reason];

  if (!template) {
    return null;
  }

  return template.replace(/\{(\w+)\}/g, (match, name) =>
    values?.[name] === undefined ? match : String(values[name])
  );
}
